import React from "react";
import { useAuth } from "components/util/helpers/providers/AuthProvider";
import WSManager from "components/util/ws";

const IDLE_FLUSH_MS = 2000;
const buffers = new Map();

const flush = (execId) => {
  const buf = buffers.get(execId);
  if (!buf) return;
  buffers.delete(execId);
  console.groupCollapsed(
    `%c[Execution ${execId}] ${buf.events.length} events · ${buf.total.toFixed(2)}s${buf.error ? " ❌" : ""}`,
    "color:#7c4dff;font-weight:bold"
  );
  buf.events.forEach((args) => console.log(...args));
  console.groupEnd();
};

const buffer = (execId, { error = false, time = 0 } = {}, ...logArgs) => {
  let buf = buffers.get(execId);
  if (!buf) {
    buf = { events: [], total: 0, error: false, timer: null };
    buffers.set(execId, buf);
  }
  buf.events.push(logArgs);
  buf.total += time || 0;
  if (error) buf.error = true;
  clearTimeout(buf.timer);
  buf.timer = setTimeout(() => flush(execId), IDLE_FLUSH_MS);
};

const onMessageReceived = ({ data }) => {
  const execId = data.execution_id;

  // Without an execution id there is nothing to group by — log inline as before.
  if (execId == null) {
    if (data.type === "error") console.error(data.traceback);
    else if (data.type === "warning") console.warn(data.message);
    else if (data.type === "execution")
      console.log(`Node: ${data.node_id} - ${data.action_name} - ${data.exec_type} - ${data.time}s`, data.input, data.output);
    else if (data.type === "info") console.info(data.message);
    return;
  }

  if (data.type === "execution")
    buffer(execId, { time: data.time },
      `Node: ${data.node_id} - ${data.action_name} - ${data.exec_type} - ${data.time}s`, data.input, data.output);
  else if (data.type === "error")
    buffer(execId, { error: true }, "%cERROR", "color:#f44", data.traceback);
  else if (data.type === "warning")
    buffer(execId, {}, "%cWARN", "color:#fb0", data.message);
  else if (data.type === "info")
    buffer(execId, {}, "INFO", data.message);
};

const DevLogs = ({ flow }) => {
  const user = useAuth();
  const developerRoomName = `DEVELOPER_${flow.id}_${sessionStorage.getItem("execution_session_id")}`;
  return user.isDeveloper ?
    <WSManager
      autoSuscribe={true}
      initialRoom={developerRoomName}
      onMessageReceived={onMessageReceived}
    /> : null;

};

export default DevLogs;